module.exports = __webpack_public_path__ + "static/data-img-c03b7b62783624e6591ca2256d29e0d2.png";